/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Customer_InfoInputs */

const vi_order_customer_info = /** @type {(inputs: Order_Customer_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin khách hàng`)
};

/**

* @param {Order_Customer_InfoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_customer_info = /** @type {((inputs?: Order_Customer_InfoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Customer_InfoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_customer_info(inputs)
});